<template>
  <a :href="url" class="p-point-notification-panel-small" v-touch:tap>
    <div class="p-point-notification-panel-small__icon">
      <slot name="icon" />
    </div>
    <div class="p-point-notification-panel-small__content">
      <p class="p-point-notification-panel-small__title">
        <slot name="title" />
      </p>
      <div class="p-point-notification-panel-small__detail">
        <slot name="detail" />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.p-point-notification-panel-small {
  box-sizing: border-box;
  display: flex;
  gap: rem(16);
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: rem(110);
  padding: rem(8);
  border-radius: px(4);

  &.tap {
    opacity: 0.5;
  }

  &__icon {
    flex-shrink: 0;
    line-height: 0;

    :deep(svg) {
      width: rem(61);
      height: rem(64);
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: rem(8);
    align-items: flex-start;
    min-width: 0;
  }

  &__title {
    width: max-content;
    max-width: rem(194);
    margin-bottom: 0;
    color: $common-white;
    font-family: $font--noto-sans-only;
    font-size: rem(16);
    font-weight: 700;
    line-height: 1.25;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    font-feature-settings: "pwid" 1, "palt" 1;

    br {
      @include large-pc {
        display: none;
      }
    }
  }

  &__detail {
    :deep(p) {
      font-family: $font--noto-sans-only;
      font-size: rem(10);
      line-height: 16px;
      letter-spacing: 0.48px;
    }
  }

  @include large-sp {
    min-height: rem(127);

    &__icon :deep(svg) {
      width: rem(90);
      height: rem(94);
    }

    &__title {
      line-height: rem(24);
      letter-spacing: 0.48px;
    }
  }
}

.p-point-notification-panel-small:hover {
  opacity: 0.5;
}
</style>
